import React from 'react'
import styled from 'styled-components'
import { Portal } from '../Portal/Portal'

const PORTAL_ID = 'AppSidePanel'

/**
 * Wrapper (portal destination) for side panel. Empty by default.
 * To render something inside the panel use `<TeleportToAppSidePanel />` component
 */
export function AppSidePanel() {
  return <Panel id={PORTAL_ID} />
}

/**
 * Render children inside `<AppSidePanel />`
 * @example
 * <TeleportToAppSidePanel>
 *   <h1>This will be rendered in side panel</h1>
 * </TeleportToAppSidePanel>
 */
export function TeleportToAppSidePanel({
  children,
  backdrop = true,
}: React.PropsWithChildren<{ backdrop?: boolean }>) {
  return (
    <React.Fragment>
      {children && backdrop && <StyledBackground />}
      <Portal id={PORTAL_ID}>{children}</Portal>
    </React.Fragment>
  )
}

const StyledBackground = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: -2vw;
  z-index: 98;
  background: white;
  opacity: 0.6;
`

const Panel = styled.div`
  pointer-events: none;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & > * {
    pointer-events: all;
  }
`
